import {Button, Column, Row, RowLR, Spinner, Text, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Link, Observer} from "web-vcore";
import {PropertiesUI_SharedProps} from "../PropertiesUI.js";
import {observer_mgl, Validate} from "mobx-graphlink";
import {ShowMessageBox} from "react-vmessagebox";
import React from "react";
import {store} from "../../../../Store/index.js";
import {JournalPathToString} from "../../../../Store/main/general/CopiedData.js";

export const Journal_CompUI = observer_mgl((props: {} & PropertiesUI_SharedProps)=>{
	const {map, mapState, obj, Change} = props;
	return (
		<Column>
			<Row>
				<Text>Journal segments:</Text>
				<Button ml={5} mdIcon="plus" onClick={()=>{
					Change(a=>a.journalSegmentPaths.push("?/?"));
				}}/>
			</Row>
			{obj.journalSegmentPaths.map((path, index)=>{
				return <JournalSegmentLinkUI key={index} {...{map, mapState, obj, path, index, Change}}/>;
			})}
		</Column>
	);
});

const JournalSegmentLinkUI = observer_mgl((props: {path: string, index: number} & PropertiesUI_SharedProps)=>{
	const {map, obj, Change, path, index} = props;
	return (
		<Row mt={5}>
			<Text style={{minWidth: 10}}>{index + 1}:</Text>
			<TextInput ml={5} style={{flex: 1, fontSize: 12}} value={path} onChange={val=>Change(a=>a.journalSegmentPaths[index] = val)}/>
			<Button ml={5} mdIcon="content-paste" enabled={store.main.copiedData.journalPath != null} onClick={()=>{
				Change(a=>a.journalSegmentPaths[index] = JournalPathToString(store.main.copiedData.journalPath!));
			}}/>
			<Link actionFunc={s=>{
				const targetJournalEntryID = path.split("/")[0];
				const validateError = Validate("UUID", targetJournalEntryID);
				if (validateError != null) {
					/*ShowMessageBox({title: "Invalid journal-entry id", message: `
						Journal-entry id: ${targetJournalEntryID}
						Invalid because: ${validateError}
					`.AsMultiline(0)});*/
					return;
				}
				s.main.page = "journal";
				s.main.journal.selectedJournalEntry = targetJournalEntryID;
			}}>
				<Button ml={5} mdIcon="link-box"/>
			</Link>
			<Button ml={5} mdIcon="delete" onClick={()=>{
				ShowMessageBox({
					title: "Delete link with journal segment?", cancelButton: true,
					message: "Are you sure you want to delete the link between this map-object and journal-segment?",
					onOK: ()=>{
						Change(a=>a.journalSegmentPaths.RemoveAt(index));
					},
				});
			}}/>
		</Row>
	);
});